import { createFileRoute, redirect } from '@tanstack/react-router';

// LLM model costs are platform-wide (not tenant-scoped) and are the cost-rate
// editor behind the usage dashboard's Costs tab, so the page now lives at the
// global /usage/llm-costs. This redirect keeps old bookmarks working.
export const Route = createFileRoute('/_protected/t/$tenantId/admin/llm-costs')({
  beforeLoad: () => {
    throw redirect({ to: '/usage/llm-costs', replace: true });
  },
});
